/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import React from 'react';
import { Spinner } from 'spin.js';
import classnames from 'classnames';

interface Props {
  isContentLoaded: boolean;
  blockRenderUntilLoaded?: boolean;
  color?: string;
  height?: number;
  width?: number;
  isFixed?: boolean;
  coverWholeScreen?: boolean;
  transparentChildren?: boolean;
  withSideNavOffset?: boolean;
}

class ContentLoader extends React.Component<Props> {

  private spinner: any;
  private elementRef: any;

  componentDidMount() {
    this.spinner = new Spinner({
      width: 2,
      radius: 10,
      length: 7,
      color: this.props.color || 'black',
      top: '50%',
    });

    if (!this.props.isContentLoaded) {
      this.spinner.spin(this.elementRef);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isContentLoaded && !this.props.isContentLoaded) {
      this.spinner.stop();
    } else if (!nextProps.isContentLoaded && this.props.isContentLoaded) {
      this.spinner.spin(this.elementRef);
    }
  }

  componentWillUnmount() {
    this.spinner.stop();
    this.spinner = null;
  }

  get styles(): any {
    const { width, height, isFixed, isContentLoaded, coverWholeScreen } = this.props;
    const styles = {
      visibility: isContentLoaded ? 'hidden' : 'visible',
    };

    if (coverWholeScreen) {
      return {
        ...styles,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      };
    }

    if (isFixed) {
      return {
        ...styles,
        position: 'relative',
        top: (window.innerHeight / 2) - 20,
      };
    }

    return {
      ...styles,
      width: `${width}px`,
      height: `${height}px`,
      position: height && width ? 'absolute' : null,
    };
  }

  renderChildren() {
    const { isContentLoaded, blockRenderUntilLoaded, transparentChildren, children } = this.props;

    if (blockRenderUntilLoaded && !isContentLoaded) return null;
    if (!transparentChildren) return children;

    return (
      <div style={{ opacity: isContentLoaded ? undefined : 0.65, pointerEvents: isContentLoaded ? undefined : 'none' }}>
        {children}
      </div>
    );
  }

  render() {
    return (
      <div>
        <div style={this.styles} className={classnames('cmp-contentloader', { 'with-sidenav-offset': this.props.withSideNavOffset })} ref={(r) => { this.elementRef = r; }} />
        { this.renderChildren() }
      </div>
    );
  }
}

export default ContentLoader;
